module.exports = __webpack_public_path__ + "static/media/control-task.a0015ab4.gif";